module.exports = __webpack_public_path__ + "pf-assets/img/logo.446f5cd5.png";